import { CircularProgress } from "@mui/material";
import MUIDataTable from "mui-datatables";
import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import KioskDark from "../../assets/images/licences/kiosk-dark.svg";
import MainDisplayDark from "../../assets/images/licences/main-display-dark.svg";
import BranchDark from "../../assets/images/licences/branch-dark.svg";
import CounterDark from "../../assets/images/licences/counter-dark.svg";
import KioskLight from "../../assets/images/licences/kiosk-light.svg";
import MainDisplayLight from "../../assets/images/licences/main-display-light.svg";
import BranchLight from "../../assets/images/licences/branch-light.svg";
import CounterLight from "../../assets/images/licences/counter-light.svg";
import axios from "axios";
import toast from "react-hot-toast";
import ChangeLicenceModal from "../ModalImpl/ChangeLicenceModal";
import { Badge } from "react-bootstrap";
import { Link } from "react-router-dom";

const LicencePage = () => {
  const [activeTab, setActiveTab] = useState(1);
  const [dashboardData, setDashboardData] = useState({});
  const [showChangeLicenceModal, setShowChangeLicenceModal] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [count, setCount] = useState(0);
  const [isLoading, setLoading] = useState(false);
  const [licenseTableData, setLicenseTableData] = useState([]);

  const baseUrl = localStorage.getItem("API_URL");
  const token = localStorage.getItem("user_token");
  const userDetails = JSON.parse(localStorage.getItem("user_details"));

  const [dataTable, setDataTable] = useState({
    page: 0,
    size: 10,
    search: "",
    order: null,
  });

  const setTable = (tableState) => {
    setDataTable({
      page: tableState.page,
      search: tableState.searchText,
      size: tableState.rowsPerPage,
      order: tableState.sortOrder,
    });
  };

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
  };

  useEffect(() => {
    getDashboardData();
  }, []);

  const getDashboardData = () => {
    axios({
      method: "GET",
      url: `${baseUrl}/license/dashboard/${userDetails.cid}`,
      headers: {
        Authorization: token,
      },
    })
      .then((res) => {
        let data = res.data.data;
        setDashboardData(data);
      })
      .catch((error) => {
        console.log(error);

        if (error.response !== undefined) {
          toast.remove();
          toast.error(error.response.data.message, {
            position: "bottom-center",
          });
        } else {
          toast.remove();
          toast.error("Something went wrong", {
            position: "bottom-center",
          });
        }
      });
  };

  const formatDate = (dateString) => {
    const parts = dateString.split(" ");

    const monthName = parts[1];
    const day = parts[2];
    const year = parts[3];

    const monthNames = {
      Jan: "01",
      Feb: "02",
      Mar: "03",
      Apr: "04",
      May: "05",
      Jun: "06",
      Jul: "07",
      Aug: "08",
      Sep: "09",
      Oct: "10",
      Nov: "11",
      Dec: "12",
    };

    const month = monthNames[monthName];

    return `${day}-${month}-${year}`;
  };

  const formattedDate = dashboardData?.expireDate
    ? formatDate(dashboardData?.expireDate)
    : "";

  const toggleChangeLicenceModal = () => {
    setShowChangeLicenceModal(!showChangeLicenceModal);
  };

  const columnsKiosks = [
    {
      label: "ID",
      name: "id",
      options: {
        sort: true,
        filter: false,
      },
    },
    {
      label: "Name",
      name: "name",
      options: {
        sort: true,
        filter: false,
      },
    },
    {
      label: "MAC Address",
      name: "mac",
      options: {
        sort: false,
        filter: false,
      },
    },
    {
      label: "Branch",
      name: "branchName",
      options: {
        sort: true,
        filter: false,
      },
    },
    {
      label: "Restricted",
      name: "restricted",
      options: {
        sort: false,
        filter: false,
        customBodyRenderLite: (dataIndex, rowIndex) => {
          if (licenseTableData === undefined) return;
          let item = licenseTableData.find(
            (item, i) => i === dataIndex
          )?.restricted;

          return (
            <>
              {item ? (
                <span className="badge badge-danger">Restricted</span>
              ) : (
                <span className="badge badge-success">Not Restricted</span>
              )}
            </>
          );
        },
      },
    },
  ];

  const columnsBranches = [
    {
      label: "Name",
      name: "name",
      options: {
        sort: true,
        filter: false,
      },
    },
    // {
    //   label: "Queue Type",
    //   name: "queueType",
    //   options: {
    //     sort: false,
    //     filter: false,
    //   },
    // },
    {
      label: "Kiosk Count",
      name: "kioskCount",
      options: {
        sort: true,
        filter: false,
      },
    },
    {
      label: "Main Display Count",
      name: "mdCount",
      options: {
        sort: true,
        filter: false,
      },
    },
    {
      label: "Counter Count",
      name: "counterId",
      options: {
        sort: true,
        filter: false,
      },
    },
    {
      label: "Region",
      name: "regionName",
      options: {
        sort: true,
        filter: false,
      },
    },
    // {
    //   label: "Restricted",
    //   name: "restricted",
    //   options: {
    //     sort: false,
    //     filter: false,
    //     customBodyRenderLite: (dataIndex, rowIndex) => {
    //       if (licenseTableData === undefined) return;
    //       let item = licenseTableData.find(
    //         (item, i) => i === dataIndex
    //       )?.restricted;

    //       return (
    //         <>
    //           {item ? (
    //             <span className="badge badge-danger">Restricted</span>
    //           ) : (
    //             <span className="badge badge-success">Not Restricted</span>
    //           )}
    //         </>
    //       );
    //     },
    //   },
    // },
    {
      label: "Actions",
      name: "",
      options: {
        sort: false,
        filter: false,
        customBodyRenderLite: (dataIndex, rowIndex) => {
          if (licenseTableData === undefined) return;
          let item = licenseTableData.find((item, i) => i === dataIndex);
          let local = {
            id: item.id,
            BranchName: item.name,
          };
          return (
            <Link
              to={`/branch-landing?bid=${item?.id}`}
              onClick={() =>
                localStorage.setItem("selected_branch", JSON.stringify(local))
              }
            >
              <button
                type="button"
                className="btn btn-sm btn-default"
                title="Navigate"
              >
                <i className="fa fa-eye"> </i>
              </button>
            </Link>
          );
        },
      },
    },
  ];

  const columnsCounters = [
    {
      label: "ID",
      name: "id",
      options: {
        sort: true,
        filter: false,
      },
    },
    {
      label: "Counter No.",
      name: "counterNo",
      options: {
        sort: false,
        filter: false,
      },
    },
    {
      label: "Branch",
      name: "branchName",
      options: {
        sort: true,
        filter: false,
      },
    },
    {
      label: "Counter",
      name: "counterName",
      options: {
        sort: false,
        filter: false,
      },
    },
    {
      label: "Category",
      name: "category",
      options: {
        sort: false,
        filter: false,
      },
    },
  ];

  const columnsDisplays = [
    {
      label: "ID",
      name: "id",
      options: {
        sort: true,
        filter: false,
      },
    },
    {
      label: "Name",
      name: "name",
      options: {
        sort: true,
        filter: false,
      },
    },
    {
      label: "MAC Address",
      name: "macAddress",
      options: {
        sort: false,
        filter: false,
      },
    },
    {
      label: "Branch",
      name: "branchName",
      options: {
        sort: true,
        filter: false,
      },
    },
    {
      label: "Restricted",
      name: "restricted",
      options: {
        sort: false,
        filter: false,
        customBodyRenderLite: (dataIndex, rowIndex) => {
          if (licenseTableData === undefined) return;
          let item = licenseTableData.find(
            (item, i) => i === dataIndex
          )?.restricted;

          return (
            <>
              {item ? (
                <span className="badge badge-danger">Restricted</span>
              ) : (
                <span className="badge badge-success">Not Restricted</span>
              )}
            </>
          );
        },
      },
    },
  ];

  const options = {
    tableBodyHeight: "55vh",
    filterType: "dropdown",
    filter: false,
    responsive: "vertical",
    serverSide: true,
    count: count,
    download: false,
    jumpToPage: true,
    search: true,
    selectableRows: "none",
    print: false,
    page: page,
    rowsPerPage: rowsPerPage,
    rowsPerPageOptions: [10, 20, 30, 50, 100],
    setTableProps: () => {
      return {
        size: "medium",
      };
    },
    onTableChange: (action, tableState) => {
      switch (action) {
        case "changePage":
          setPage(tableState.page);
          getLicenseTableData(
            tableState.page,
            tableState.sortOrder,
            tableState.searchText,
            tableState.rowsPerPage
          );
          setTable(tableState);
          break;
        case "sort":
          getLicenseTableData(
            tableState.page,
            tableState.sortOrder,
            tableState.searchText,
            tableState.rowsPerPage
          );
          setTable(tableState);
          break;
        case "changeRowsPerPage":
          setRowsPerPage(tableState.rowsPerPage);
          getLicenseTableData(
            tableState.page,
            tableState.sortOrder,
            tableState.searchText,
            tableState.rowsPerPage
          );
          setTable(tableState);
          break;
        case "search":
          getLicenseTableData(
            tableState.page,
            tableState.sortOrder,
            tableState.searchText,
            tableState.rowsPerPage
          );
          setTable(tableState);
          break;
        default:
          break;
      }
    },
  };

  const getLicenseTableData = (page, sortOrder, search, size) => {
    setLoading(true);
    axios({
      method: "POST",
      url: `${baseUrl}/license/table/customer/${userDetails.cid}/tab/${activeTab}`,
      headers: {
        Authorization: token,
      },
      data: {
        page: page,
        size: size,
        sort: sortOrder,
        searchText: search,
      },
    })
      .then((res) => {
        const data = res.data.data;

        setCount(data.totalElements);
        setLicenseTableData(data.content);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);

        if (error.response !== undefined) {
          toast.remove();
          toast.error(error.response.data.message, {
            position: "bottom-center",
          });
        } else {
          toast.remove();
          toast.error("Something went wrong", {
            position: "bottom-center",
          });
        }
      });
  };

  useEffect(() => {
    setRowsPerPage(10);
    setPage(0);
    getLicenseTableData(0, null, null, rowsPerPage);
  }, [activeTab]);

  return (
    <div className="container-fluid">
      <div className="block-header">
        <div className="row clearfix">
          <div className="col-md-6 col-sm-6">
            <h1> Licences</h1>
          </div>
          <div className="col-md-6 col-sm-6 d-flex justify-content-end align-items-center">
            {/* <p className="p-0 m-0">Expires in</p>
            <div className=" pl-2" data-provide="datepicker">
              <DatePicker
                className="input-sm form-control"
                value={formattedDate}
                readOnly
                dateFormat="dd-MM-yyyy"
              />
            </div> */}
            <a
              href="#"
              className="btn btn-sm btn-primary ml-4"
              title=""
              onClick={(e) => {
                e.preventDefault();
                toggleChangeLicenceModal();
              }}
            >
              Change Licence
            </a>
          </div>
        </div>
      </div>

      <div className="row clearfix">
        {/* <Barchart /> */}
        <div className="col-lg-3 col-md-6">
          <div
              className={`card landing-page-main-cards"}`}
          >
            <div className="body w_knob">
              <div className="c_know">
                <div className="text-center h3 text-blue-fade">
                  {dashboardData?.licenseBranchCount}
                </div>
              </div>
              <div className="text-right" style={{ textAlign: 'right' }}>
                <h6>Branch Licences</h6>
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-3 col-md-6">
          <div
              className={`card landing-page-main-cards"}`}
          >
            <div className="body w_knob">
              <div className="c_know">
                <div className="text-center h3 text-blue-fade">
                  {dashboardData?.licenseCountersCount}
                </div>
              </div>
              <div className="text-right">
                <h6>Counter Licences</h6>
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-3 col-md-6">
          <div
              className={`card landing-page-main-cards"}`}
          >
            <div className="body w_knob">
              <div className="c_know">
                <div className="text-center h3 text-blue-fade">
                  {dashboardData?.licenseMainDisplayCount}
                </div>
              </div>
              <div className="text-right">
                <h6>Main Display Licences</h6>
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-3 col-md-6">
          <div
              className={`card landing-page-main-cards"}`}
          >
            <div className="body w_knob">
              <div className="c_know">
                <div className="text-center h3 text-blue-fade">
                  {dashboardData?.licenseKioskCount}
                </div>
              </div>
              <div className="text-right">
                <h6>Kiosk Licences</h6>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row clearfix mt-2">
        <div className=" col-lg-3 mb-4 pl-0">
          {/*  */}
          {/* <div className="card h-50">
            <div className="body h-100 text-center d-flex ">
              <div className=" col-lg-3 m-0 p-0">
                <img src={BranchDark} height="85px" width="85px" />
              </div>
              <div className=" col-lg-9 m-0 p-0">
                <div className="d-flex h-100 auth-main align-items-center">
                  <h4 className="text-blue-fade">
                    {dashboardData?.branchCount || "-"}/
                    {dashboardData?.licenseBranchCount || "-"}
                  </h4>
                  <p className="p-0 m-0">Branches</p>
                </div>
              </div>
            </div>
          </div> */}

          <div className="card h-50">
            <div className="body h-100 text-center d-flex ">
              <div className=" col-lg-5 m-0 p-0 ">
                <h6 className="text-blue-fade mb-4">Branches</h6>

                <img src={BranchDark} height="75px" width="75px" />
              </div>
              <div className=" col-lg-7 m-0 p-0">
                <div>
                  <p className="p-0 my-0 mr-2">Remaining</p>
                  <h1 className="text-green my-0 font-weight-bold">
                    {dashboardData?.licenseBranchCount -
                      dashboardData?.branchCount || "-"}
                  </h1>
                </div>
                <div className="px-2 d-flex w-100 align-items-center justify-content-around my-2">
                  <div>
                    <p className="p-0 m-0">Used</p>
                    <h4 className="text-blue-fade m-0">
                      {dashboardData?.branchCount || "-"}
                    </h4>
                  </div>
                  <div>
                    <p className="p-0 m-0">License</p>
                    <h4 className="text-blue-fade m-0">
                      {dashboardData?.licenseBranchCount || "-"}
                    </h4>
                  </div>
                  {/* <h4 className="text-blue-fade">
                      {dashboardData?.kioskCount || "-"}/
                      {dashboardData?.licenseKioskCount || "-"}
                    </h4> */}
                </div>
              </div>
            </div>
          </div>

          <div className="card h-50">
            <div className="body h-100 text-center d-flex ">
              <div className=" col-lg-5 m-0 p-0 ">
                <h6 className="text-blue-fade mb-4">Main Displays</h6>

                <img src={MainDisplayDark} height="75px" width="75px" />
              </div>
              <div className=" col-lg-7 m-0 p-0">
                <div>
                  <p className="p-0 my-0 mr-2">Remaining</p>
                  <h1 className="text-green my-0 font-weight-bold">
                    {dashboardData?.licenseMainDisplayCount -
                      dashboardData?.mainDisplayCount || "-"}
                  </h1>
                </div>
                <div className="px-2 d-flex w-100 align-items-center justify-content-around mt-4 mb-0">
                  <div>
                    <p className="p-0 m-0">Used</p>
                    <h4 className="text-blue-fade m-0">
                      {dashboardData?.mainDisplayCount || "-"}
                    </h4>
                  </div>
                  <div>
                    <p className="p-0 m-0">License</p>
                    <h4 className="text-blue-fade m-0">
                      {dashboardData?.licenseMainDisplayCount || "-"}
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className=" col-lg-3 mb-4 pl-0">
          <div className="card h-50">
            <div className="body h-100 text-center d-flex ">
              <div className=" col-lg-5 m-0 p-0 ">
                <h6 className="text-blue-fade mb-4">Counters</h6>

                <img src={CounterDark} height="75px" width="75px" />
              </div>
              <div className=" col-lg-7 m-0 p-0">
                <div>
                  <p className="p-0 my-0 mr-2">Remaining</p>
                  <h1 className="text-green my-0 font-weight-bold">
                    {dashboardData?.licenseCountersCount -
                      dashboardData?.countersCount || "-"}
                  </h1>
                </div>
                <div className="px-2 d-flex w-100 align-items-center justify-content-around mt-4 mb-0">
                  <div>
                    <p className="p-0 m-0">Used</p>
                    <h4 className="text-blue-fade m-0">
                      {dashboardData?.countersCount || "-"}
                    </h4>
                  </div>
                  <div>
                    <p className="p-0 m-0">License</p>
                    <h4 className="text-blue-fade m-0">
                      {dashboardData?.licenseCountersCount || "-"}
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="card h-50">
            <div className="body h-100 text-center d-flex ">
              <div className=" col-lg-5 m-0 p-0 ">
                <h6 className="text-blue-fade mb-4">Kiosks</h6>

                <img src={KioskDark} height="75px" width="75px" />
              </div>
              <div className=" col-lg-7 m-0 p-0">
                <div>
                  <p className="p-0 my-0 mr-2">Remaining</p>
                  <h1 className="text-green my-0 font-weight-bold">
                    {dashboardData?.licenseKioskCount -
                      dashboardData?.kioskCount || "-"}
                  </h1>
                </div>
                <div className="px-2 d-flex w-100 align-items-center justify-content-around mt-4 mb-0">
                  <div>
                    <p className="p-0 m-0">Used</p>
                    <h4 className="text-blue-fade m-0">
                      {dashboardData?.kioskCount || "-"}
                    </h4>
                  </div>
                  <div>
                    <p className="p-0 m-0">License</p>
                    <h4 className="text-blue-fade m-0">
                      {dashboardData?.licenseKioskCount || "-"}
                    </h4>
                  </div>
                  {/* <h4 className="text-blue-fade">
                      {dashboardData?.kioskCount || "-"}/
                      {dashboardData?.licenseKioskCount || "-"}
                    </h4> */}
                </div>
              </div>
            </div>
          </div>
          {/* <div className="card h-50">
            <div className="body h-100 text-center d-flex ">
              <div className=" col-lg-3 m-0 p-0 ">
                <img src={MainDisplayDark} height="85px" width="85px" />
              </div>
              <div className=" col-lg-9 m-0 p-0">
                <div className="d-flex h-100 auth-main align-items-center">
                  <h4 className="text-blue-fade">
                    {dashboardData?.mainDisplayCount || "-"}/
                    {dashboardData?.licenseMainDisplayCount || "-"}
                  </h4>
                  <p className="p-0 m-0">Main Displays</p>
                </div>
              </div>
            </div>
          </div> */}
        </div>
        <div className=" col-lg-6 mb-2 pl-0">
          <div className="card h-100 ">
            <div className="text-left body h-100 w-100 d-flex auth-main align-items-stretch justify-content-between">
              {/* <i className="fa fa-check"></i> */}
              {/* <h6 className="">Completed Reservations</h6> */}

              <div className="">
                <small className="float-right text-muted">
                  {dashboardData?.usedBranchPercentage}%
                </small>
                <span>Branches</span>
                <div className="progress progress-xs mt-2">
                  <div
                    style={{ width: `${dashboardData?.usedBranchPercentage}%` }}
                    className="progress-bar"
                  />
                </div>
              </div>

              <div className="">
                <small className="float-right text-muted">
                  {dashboardData?.usedCountersPercentage}%
                </small>
                <span>Counters</span>
                <div className="progress progress-xs mt-2">
                  <div
                    style={{
                      width: `${dashboardData?.usedCountersPercentage}%`,
                    }}
                    className="progress-bar"
                  />
                </div>
              </div>

              <div className="">
                <small className="float-right text-muted">
                  {dashboardData?.usedDisplayedPercentage}%
                </small>
                <span>Main Displays</span>
                <div className="progress progress-xs mt-2">
                  <div
                    style={{
                      width: `${dashboardData?.usedDisplayedPercentage}%`,
                    }}
                    className="progress-bar"
                  />
                </div>
              </div>

              <div className="">
                <small className="float-right text-muted">
                  {dashboardData?.usedKiosksPercentage}%
                </small>
                <span>Kiosks</span>
                <div className="progress progress-xs mt-2">
                  <div
                    style={{ width: `${dashboardData?.usedKiosksPercentage}%` }}
                    className="progress-bar"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row clearfix">
        <div className="col-sm-12 pl-0 mt-4">
          <div className="card">
            <ul className="nav nav-tabs3">
              <li className="nav-item cursor-pointer">
                <a
                  className={`nav-link ${activeTab === 1 ? "active" : ""}`}
                  data-toggle="tab"
                  onClick={() => handleTabClick(1)}
                >
                  Branches
                </a>
              </li>
              <li className="nav-item cursor-pointer">
                <a
                  className={`nav-link ${activeTab === 2 ? "active" : ""}`}
                  data-toggle="tab"
                  onClick={() => handleTabClick(2)}
                >
                  Counters
                </a>
              </li>
              <li className="nav-item cursor-pointer">
                <a
                  className={`nav-link ${activeTab === 3 ? "active" : ""}`}
                  data-toggle="tab"
                  onClick={() => handleTabClick(3)}
                >
                  Main Displays
                </a>
              </li>
              <li className="nav-item cursor-pointer">
                <a
                  className={`nav-link ${activeTab === 4 ? "active" : ""}`}
                  data-toggle="tab"
                  // href="#TODAY"
                  onClick={() => handleTabClick(4)}
                >
                  Kiosks
                </a>
              </li>
            </ul>
            <div className="body p-0 appointment-userlist-table-container">
              <MUIDataTable
                title={
                  <>
                    {count}
                    {count === 1 ? " record" : " records"}
                    {isLoading && (
                      <>
                        &nbsp;&nbsp;&nbsp;
                        <CircularProgress color="primary" size={10} />
                      </>
                    )}
                  </>
                }
                data={licenseTableData}
                columns={
                  activeTab === 1
                    ? columnsBranches
                    : activeTab === 2
                    ? columnsCounters
                    : activeTab === 3
                    ? columnsDisplays
                    : columnsKiosks
                }
                options={options}
                className="text-center-table"
              />
            </div>
          </div>
        </div>
      </div>
      <ChangeLicenceModal
        showChangeLicenceModal={showChangeLicenceModal}
        toggle={toggleChangeLicenceModal}
        expireDate={dashboardData?.expireDate}
        // expireDate={formattedDate}
      />
    </div>
  );
};

export default LicencePage;
